import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function HevcIcon(props: IconProps) {
    return <Icon {...props} iconKey={"hevc"}/>
}
